(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('ItemsSummaryController', Controller);

    Controller.$inject = ['$scope', 'searchService', '$stateParams', '$state'];

    function Controller($scope, searchService, $stateParams, $state) {
        $scope.ItemSearchActions = [];
        $scope.risks = {
            results: 0,
            loading: true,
            searchLink: ''
        };
        $scope.controls = {
            results: 0,
            loading: true,
            searchLink: ''
        };
        $scope.recommendations = {
            results: 0,
            loading: true,
            searchLink: ''
        };
        $scope.actionPlans = {
            results: 0,
            loading: true,
            searchLink: ''
        };

        // Get configuration
        searchService.getConfiguration()
            .then(function (conf) {
                $scope.ItemSearchActions = _.filter(conf.ItemSearchActions, function(item) {
                    return !item.hasOwnProperty('ParentItemSearchActionID');
                });

                // Init contexts
                initSummary();
            });

        $scope.navigateToSearch = function(searchCriteria) {
            $stateParams.q = searchCriteria;
            $state.reload();
        }

        function initSummary() {
            // For each ItemSearchActions, search item
            _.forEach($scope.ItemSearchActions, function(searchAction) {

                if (searchAction.Name === 'Risk') {
                    $scope.risks.loading = true;
                    $scope.risks.searchLink = searchAction.FilteredSearch;
                    searchService.searchRisks(searchAction.FilteredSearch, true)
                        .then(function (res) {
                            $scope.risks.results = res.Results.length;
                            $scope.risks.loading = false;
                        });
                }

                if (searchAction.Name === 'Control') {
                    $scope.controls.loading = true;
                    $scope.controls.searchLink = searchAction.FilteredSearch;
                    searchService.searchControls(searchAction.FilteredSearch, true)
                        .then(function (res) {
                            $scope.controls.results = res.Results.length;
                            $scope.controls.loading = false;
                        });
                }

                if (searchAction.Name === 'Recommendations') {
                    $scope.recommendations.loading = true;
                    $scope.recommendations.searchLink = searchAction.FilteredSearch;
                    searchService.searchRecommendations(searchAction.FilteredSearch, true)
                        .then(function (res) {
                            $scope.recommendations.results = res.Results.length;
                            $scope.recommendations.loading = false;
                        });
                }

                if (searchAction.Name === 'Action Plan') {
                    $scope.actionPlans.loading = true;
                    $scope.actionPlans.searchLink = searchAction.FilteredSearch;
                    searchService.searchActionPlans(searchAction.FilteredSearch, true)
                        .then(function (res) {
                            $scope.actionPlans.results = res.Results.length;
                            $scope.actionPlans.loading = false;
                        });
                }
            });
        }
    }
})();